<sk-modal-content [title]="'label.dms.SelectFiles' | translate"
                  confirmByKeypress
                  (confirmed)="onSelect()"
                  (cancelled)="closeWithoutResult()"
                  (closed)="closeWithoutResult()"
                  [allowCancelIfChildFocused]="true"
                  [allowConfirmIfChildFocused]="true">

  <ng-container id="sk-modal-body">
    <div class="app-content-container">

      <sk-resizable class="folders-tree-resizable"
                    [directions]="resizeDirections()"
                    [rFlex]="true"
                    [style.width]="foldersTreeWidth()"
                    [style.margin-left]="foldersTreeMarginLeft()"
                    (resizeEnd)="onResizeEnd($event)">

        <div class="folders-tree">
          @if (showProjectSelector()) {
            <sk-select iris-entity="project"
                       class="project-selector"
                       appendTo="body"
                       [required]="true"
                       [label]="'label.Project' | translate"
                       [ngModel]="projectId()"
                       (ngModelChange)="selectedProjectChanged($event)">
            </sk-select>
          }

          @if (showProjectInfoMessage()) {
            <p>{{ projectInfoMessage() | translate }}</p>
          }

          @if (!!projectId()) {
            <iris-dms-mat-folders-tree class="folders-tree-container tree-root">
            </iris-dms-mat-folders-tree>
          }
        </div>

        <div class="toggle-folders-button">
          <sk-button appearance="icon"
                     (click)="toggleFoldersTree()"
                     data-test="select-files-toggle-folders-tree-button">
            <em class="icon far" [class]="toggleFoldersTreeIconClass()"></em>
          </sk-button>
        </div>
      </sk-resizable>

      @if (!!projectId() && !!selectedFolderId()) {
        <div class="files-list-container ps-2">
          @if (showFileUploader()) {
            <iris-file-uploader [disabled]="!selectedFolderId() || !hasFolders()"
                                [folderId]="selectedFolderId()"
                                (fileUploaded)="onFileSuccessUpload($event)">
            </iris-file-uploader>
          }

          @if (!!selectedFolderId()) {
            @if (showTileView()) {
              <iris-tile-view-lite [multiple]="multiple()"
                                   [items]="files()"
                                   [loading]="filesLoading()"
                                   [selectedFiles]="selectedFiles()"
                                   (scrolled)="onScroll()"
                                   (selectedFilesChanged)="onTileViewRowSelectionChange($event)"
                                   (filterChanged)="onFilesFilterChanged($event)">
              </iris-tile-view-lite>
            } @else {
              <ag-grid-angular class="ag-theme-iris"
                               agGridFitWidth
                               [gridOptions]="gridOptions"
                               [rowData]="files()"
                               (gridReady)="onGridReady($event)"
                               (selectionChanged)="onRowSelectionChange($event)"
                               [irisPagination]="true"
                               [irisPage]="page()"
                               [irisPageSize]="pageSize"
                               [irisTotalItemsCount]="total()"
                               [irisShowNumberOfCurrentItems]="true"
                               [irisShowPageSizeSelector]="false"
                               [irisGridMode]="gridMode"
                               (irisPageChanged)="contentPageChanged($event)" />
            }
          }
        </div>
      } @else if(!projectId()) {
        <iris-empty-content-view [label]="'text.dms.NoFolderOrProjectSelected'"
                                 [message]="'text.dms.ChooseFolderOrProject'">
        </iris-empty-content-view>
      }
    </div>
  </ng-container>

  <ng-container id="sk-modal-footer-buttons">
    <sk-button [color]="'primary'"
               [label]="'label.Select' | translate"
               data-test="modal-footer-confirm-button"
               [disabled]="!hasSelectedFiles()"
               (click)="onSelect()">
      <ng-template buttonPrefix>
        <i class="fas fa-check"></i>
      </ng-template>

      <ng-template buttonSuffix>
        @if (hasSelectedFiles()) {
          ({{selectedFiles()?.length}} {{ 'label.Files' | translate }})
        }
      </ng-template>
    </sk-button>
  </ng-container>
</sk-modal-content>
